import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthProvider';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminLogin } from './pages/AdminLogin';
import { AdminIndex } from './pages/AdminIndex';
import { AdminKanban } from './pages/AdminKanban';
import { AdminCinema } from './pages/AdminCinema';
import { AdminCertifications } from './pages/AdminCertifications';
import { AdminExpenses } from './pages/AdminExpenses';
import { AdminExperiences } from './pages/AdminExperiences';
import { AdminSkills } from './pages/AdminSkills';
import { AdminProjects } from './pages/AdminProjects';

export function AdminRouter() {
  return (
    <AuthProvider>
      <Routes>
        {/* Login - accessible sans authentification */}
        <Route path="login" element={<AdminLogin />} />

        {/* Dashboard - protégé */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AdminIndex />
            </ProtectedRoute>
          }
        />

        {/* Kanban - protégé */}
        <Route
          path="kanban"
          element={
            <ProtectedRoute>
              <AdminKanban />
            </ProtectedRoute>
          }
        />

        {/* Cinema - protégé */}
        <Route
          path="cinema"
          element={
            <ProtectedRoute>
              <AdminCinema />
            </ProtectedRoute>
          }
        />

        {/* Certifications - protégé */}
        <Route
          path="certifications"
          element={
            <ProtectedRoute>
              <AdminCertifications />
            </ProtectedRoute>
          }
        />

        {/* Dépenses - protégé */}
        <Route
          path="expenses"
          element={
            <ProtectedRoute>
              <AdminExpenses />
            </ProtectedRoute>
          }
        />

        {/* Expériences - protégé */}
        <Route
          path="experiences"
          element={
            <ProtectedRoute>
              <AdminExperiences />
            </ProtectedRoute>
          }
        />

        {/* Compétences - protégé */}
        <Route
          path="skills"
          element={
            <ProtectedRoute>
              <AdminSkills />
            </ProtectedRoute>
          }
        />

        {/* Projets - protégé */}
        <Route
          path="projects"
          element={
            <ProtectedRoute>
              <AdminProjects />
            </ProtectedRoute>
          }
        />

        {/* Redirection par défaut */}
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AuthProvider>
  );
}
